import { render, staticRenderFns } from "./CardRowMagazineItemReadOnly.vue?vue&type=template&id=f24bfb98&"
import script from "./CardRowMagazineItemReadOnly.vue?vue&type=script&lang=js&"
export * from "./CardRowMagazineItemReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports